module.exports = __webpack_public_path__ + "static/media/company_img.22d8489d.svg";